<template>
    <div v-if="currentFile" class="relative w-full rounded-xl overflow-hidden min-h-80">
        <template v-if="!fileNotReleased">
            <FileEmbed
                v-if="
                    currentFile.type === PLAYER_FILE_TYPES.embed ||
                    currentFile.type === PLAYER_FILE_TYPES.google ||
                    (currentFile.type === PLAYER_FILE_TYPES.video &&
                        currentFile.videoSrc !== PLAYER_FILE_TYPES.other)
                "
            />

            <FileVideoOther
                v-if="
                    currentFile.type === PLAYER_FILE_TYPES.video &&
                    currentFile.videoSrc === PLAYER_FILE_TYPES.other
                "
            />

            <FileAudio v-if="currentFile.type === PLAYER_FILE_TYPES.audio" />

            <FilePdf v-if="currentFile.type === PLAYER_FILE_TYPES.pdf" />

            <FileImage v-if="currentFile.type === PLAYER_FILE_TYPES.image" />

            <FileText v-if="currentFile.type === PLAYER_FILE_TYPES.text" />

            <FileDownload v-if="currentFile.type === PLAYER_FILE_TYPES.file" />
        </template>
        <FileCounter v-else />
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { PLAYER_FILE_TYPES } from "@/apps/player/services/players.service";
import FileEmbed from "./FileEmbed.vue";
import FileVideoOther from "./FileVideoOther.vue";
import FileAudio from "./FileAudio.vue";
import FilePdf from "./FilePdf.vue";
import FileImage from "./FileImage.vue";
import FileText from "./FileText.vue";
import FileDownload from "./FileDownload.vue";
import FileCounter from "./FileCounter.vue";

export default {
    name: "MainFile",
    components: {
        FileEmbed,
        FileVideoOther,
        FileAudio,
        FilePdf,
        FileImage,
        FileText,
        FileDownload,
        FileCounter,
    },
    data() {
        return {
            PLAYER_FILE_TYPES,
        };
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        ...mapState("player/view", ["player"]),
        ...mapGetters("player/view", ["currentFile"]),
        fileNotReleased() {
            return (
                !this.preview &&
                this.currentFile.releaseAt &&
                new Date(this.currentFile.releaseAt) > new Date()
            );
        },
    },
};
</script>
